import { ASaltoWecosystemCompany } from "./ASaltoWecosystemCompany";

export const BarSup = ({ email, logoutFunction, isMobile }) => {
  return (
    <div className="barSup">
      {!isMobile && (
        <a
          href="https://saltowecosystem.com"
          target="_blank"
          rel="noopener noreferrer"
          className="group-company"
          tabIndex="-1"
        >
          <ASaltoWecosystemCompany />
        </a>
      )}
      <div className="barSup-items">
        <button
          className="barSupItem barSupItem-green barSupItem-user"
          onClick={
            logoutFunction ??
            (() => {
              console.error("logoutFunction not defined");
            })
          }
        >
          <span className="itemContent">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M3.72461 15V13.4833C3.72461 11.7333 5.11381 10.3333 6.85032 10.3333H10.1497C11.8862 10.3333 13.2754 11.7333 13.2754 13.4833V15M5.37429 4.03333C5.37429 5.78333 6.76349 7.18333 8.5 7.18333C10.2365 7.18333 11.6257 5.78333 11.6257 4.03333C11.6257 2.28333 10.1207 1 8.5 1C6.87926 1 5.37429 2.28333 5.37429 4.03333Z"
                stroke="#111111"
                strokeWidth="1.5"
                strokeLinecap="square"
                strokeLinejoin="round"
              />
            </svg>
            <p>{email ?? "nombreapellido@email.com"}</p>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M11.3264 11.766L10.2446 10.646L11.5698 9.27401L12.1242 8.92401L12.0431 8.68601L11.394 8.79801H4.86279V7.20201H11.394L12.0431 7.31401L12.1242 7.07601L11.5698 6.72601L10.2446 5.35401L11.3264 4.23401L14.4094 7.42601V8.57401L11.3264 11.766Z"
                fill="#111111"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.2793 1.95691H9.6355V3.45691H2.7793V12.5431H9.6355V14.0431H1.2793V1.95691Z"
                fill="#111111"
              />
            </svg>
          </span>
        </button>
      </div>
    </div>
  );
};
